<template>
  <circle-statistic
    icon="shopping_cart"
    :title="$t('customs.dashboard.productsPerSaleAvg')"
    :sub-title="subtitle"
    :value="periodDiffPositiveValue"
    :text="productPerSaleAverage.toFixed(2)"
    :color="color"
    :caption="
      periodDiffIsInfinity
        ? ''
        : $t('customs.dashboard.previousPeriod') + ' ' + productPerSaleAveragePrevious.toFixed(2)
    "
    :is-negative="Math.sign(percentagePeriodDiff) !== 1"
    :loading="loading"
  >
  </circle-statistic>
</template>

<script>
  import CircleStatistic from '@/components/Widgets/statistic/CircleStatistic'
  export default {
    name: 'ProductsPerSaleAverageIndicator',
    components: {
      CircleStatistic
    },
    props: {
      loading: Boolean,
      productPerSaleAverage: Number,
      productPerSaleAveragePrevious: Number
    },
    computed: {
      percentagePeriodDiff() {
        let diff =
          ((this.productPerSaleAverage - this.productPerSaleAveragePrevious) / this.productPerSaleAveragePrevious) * 100
        if (!isNaN(diff)) {
          return Math.round(diff)
        } else {
          return 0
        }
      },
      periodDiffPositiveValue() {
        let diff = this.percentagePeriodDiff
        if (diff < 0) {
          return -diff
        } else {
          return diff
        }
      },
      subtitle() {
        return this.percentagePeriodDiff === Infinity
          ? this.$t('customs.dashboard.unavailableDataForPreviousPeriod')
          : this.percentagePeriodDiff + '% ' + this.$t('customs.dashboard.vsPreviousPeriod')
      },
      periodDiffIsInfinity() {
        return this.percentagePeriodDiff === Infinity
      },
      color() {
        if (Math.sign(this.percentagePeriodDiff) === 1) {
          return 'green'
        } else if (Math.sign(this.percentagePeriodDiff) === -1) {
          return 'red'
        } else {
          return 'primary'
        }
      }
    }
  }
</script>

<style scoped></style>
